module.exports = __webpack_public_path__ + "static/media/r_arrow.6e3a7fcf.svg";